import { Navbar, Nav, NavbarBrand, Container } from "react-bootstrap";
import Icon from "components/Icon/Icon";
import AuthMenu from "components/Auth/AuthMenu";

const Header = ({ children, menuOpened, handleMenu, menuId }) => {
  return (
    <header className="header fixed-top">
      <Navbar expand bg="dark" data-bs-theme="dark" className="py-0" >
        <Container fluid className="justify-content-center">
          {Boolean(handleMenu) && (
            <Nav className="me-auto">
              <Nav.Link
                active
                onClick={handleMenu}
                data-toggle="collapse"
                aria-controls={menuId || ""}
                aria-expanded={Boolean(menuOpened)}
              >
                <Icon icon="menu"/>
              </Nav.Link>
            </Nav>
          )}
          <NavbarBrand>{children}</NavbarBrand>
          <Nav className="ms-auto">
            <AuthMenu />
          </Nav>
        </Container>
      </Navbar>
    </header>
  );
};


export default Header;
